import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { CookieService } from 'ngx-cookie-service';
import { environment } from "../../../../../environments/environment";
import { ProviderSite, ProviderSiteDto } from "../../../models/provider-parking/provider-site.model";
import { ApiMethodService } from "../../../../tools/services/api/method-api/apiMethod.service";
import { MapperProviderSiteService } from '../../../mappers/provider-parking/mapper-provider-site.service';

@Injectable({
    providedIn: 'root',
})
export class ApiProviderSiteService {
    private baseUrl = environment.apiPrivateUrl;

    constructor(
        private cookieService: CookieService,
        private apiMethodService: ApiMethodService,
        private mapper: MapperProviderSiteService
    ) {}

    /**
     * ดึงข้อมูลรายการพื้นที่ให้บริการ
     */
    getProviderSite(): Observable<ProviderSite[]> {
        const token = this.cookieService.get('token');
        return this.apiMethodService.request<ProviderSiteDto[]>(
            '/backoffice/GetProviderSite',
            'GET',
            this.baseUrl,
            {
                labelLog: 'GetProviderSite',
                token: token,
                headerOnly: false,
                isConsoleLog: true
            }
        ).pipe(
            map(dtos => (dtos || []).map(dto => this.mapper.mapProviderSiteFromDto(dto)))
        );
    }

    /**
     * สร้างหรือแก้ไขข้อมูลพื้นที่ให้บริการ
     */
    createProviderSite(payload: ProviderSite): Observable<any> {
        const token = this.cookieService.get('token');
        const dto = this.mapper.mapProviderSiteToDto(payload);
        return this.apiMethodService.request<any>(
            '/backoffice/CreateProviderSite',
            'POST',
            this.baseUrl,
            {
                labelLog: 'CreateProviderSite',
                token: token,
                headerOnly: false,
                isConsoleLog: true,
                body: dto
            }
        );
    }
}
